<div
  [class]="'simple-table-wrapper flex flex-col ' + tableConfig.totalTableStyles"
  [ngClass]="{ hidden: !dataSource || !tableConfig }"
>
  <div class="h-auto">
    <div class="flex justify-start w-full items-center mb-1">
      @if (tableConfig.hasSearchbox) {
        <div
          [ngClass]="
            tableConfig.searchboxStyles
              ? tableConfig.searchboxStyles
              : 'w-[75%] mr-2'
          "
        >
          <phoenix-searchbox
            [searchValue]="searchValue"
            [disabled]="loadingTable"
            [placeholder]="searchBoxPlaceholder"
            (searchboxChange)="onSearchboxChange($event)"
          ></phoenix-searchbox>
        </div>
      }
      @if (tableConfig.title) {
        <div>
          <strong> {{ tableConfig.title }}</strong>
        </div>
      }
      <div class="flex-1">
        <ng-content></ng-content>
      </div>
    </div>
    <div class="h-1">
      @if (loadingTable) {
        <mat-progress-bar
          class="absolute"
          [mode]="'indeterminate'"
        ></mat-progress-bar>
      }
    </div>
  </div>
  <div class="flex flex-col h-full w-full relative overflow-hidden">
    <div [class]="tableExtraStyles() + ' flex-grow'" cdkScrollable>
      @if (tableConfig.columnFilter && tableConfig.id) {
        <div
          class="overflow-hidden theme-bg-2 absolute top-0 right-0 h-[20px] w-[20px] z-10 flex justify-center items-center rounded-full shadow-md"
        >
          <button
            mat-icon-button
            class="material-icons-outlined scale-[.7] w-full h-full"
            aria-label="Filter"
            type="button"
            (click)="onFilterButtonClick()"
          >
            filter_list
          </button>
        </div>
      }

      <ng-content select="[extraOptionsBefore]"></ng-content>
      <table
        mat-table
        matSort
        cdkDropListGroup
        multiTemplateDataRows
        [ngClass]="tableConfig.autoTable ? '' : 'simple-table__table'"
        class="w-full"
        [attr.aria-label]="'simpleTable'"
        [dataSource]="dataSource"
        (matSortChange)="onSortTable()"
        [cdkDropListDisabled]="!tableConfig.dragAndDrop"
        cdkDropList
        cdkDropListLockAxis="x"
        cdkDropListOrientation="horizontal"
        (cdkDropListDropped)="dropListDropped($event)"
      >
        <!-- Expand Column -->
        <ng-container matColumnDef="expand">
          <th
            class="w-[5%] simple-table__action-column"
            mat-header-cell
            *matHeaderCellDef
          >
            &nbsp;
          </th>
          <td
            class="w-[5%] simple-table__action-column"
            mat-cell
            *matCellDef="let element"
            (click)="isRowCorrupted(element) ? $event.stopPropagation() : null"
          >
            <button
              type="button"
              class="scale-[0.8] simple-table__toggle-button"
              [class.simple-table__toggle-button--expanded]="
                isExpanded(element)
              "
              mat-icon-button
              aria-label="expand row"
              [disabled]="isRowCorrupted(element)"
              [matTooltip]="
                isRowCorrupted(element) ? 'Corrupted information' : ''
              "
              (click)="clickExpanded(element); $event.stopPropagation()"
            >
              <mat-icon>keyboard_arrow_down</mat-icon>
            </button>
          </td>
        </ng-container>

        <!-- Expanded Content Column -->
        <ng-container matColumnDef="expandedDetail">
          <td
            mat-cell
            *matCellDef="let row"
            [attr.colspan]="displayedColumns.length"
          >
            <div
              class="simple-table__detail-wrapper w-full"
              [class.simple-table__detail-wrapper--expanded]="isExpanded(row)"
            >
              <div class="simple-table__detail w-full">
                @if (tableConfig.templateExpandible?.()) {
                  <div class="w-full">
                    <ng-container
                      *ngTemplateOutlet="
                        tableConfig.templateExpandible?.() ?? null;
                        context: {
                          row: row,
                          expanded: isExpanded(row),
                        }
                      "
                    ></ng-container>
                  </div>
                }
              </div>
            </div>
          </td>
        </ng-container>

        <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
          <th
            class="w-[4%] simple-table__action-column"
            mat-header-cell
            *matHeaderCellDef
          >
            <mat-checkbox
              (change)="$event ? toggleAllRows() : null"
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()"
            >
            </mat-checkbox>
          </th>
          <td
            class="w-[4%] simple-table__action-column"
            mat-cell
            *matCellDef="let row"
            (click)="isRowCorrupted(row) ? $event.stopPropagation() : null"
          >
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="
                $event ? selection.toggle(row) : null; onSelectionChange()
              "
              (keyup)="(null)"
              [checked]="selection.isSelected(row)"
              [disabled]="isRowCorrupted(row)"
              [matTooltip]="isRowCorrupted(row) ? 'Corrupted information' : ''"
            >
            </mat-checkbox>
          </td>
        </ng-container>

        @for (
          column of tableConfig.columnDefList;
          track column.key;
          let i = $index
        ) {
          <ng-container matColumnDef="{{ column.key }}">
            <th
              class="{{ column.class }}"
              [ngClass]="{ 'hover:cursor-pointer': tableConfig.dragAndDrop }"
              cdkDrag
              [cdkDragData]="{ name: column.key, columnIndex: i }"
              mat-header-cell
              *matHeaderCellDef
              [matTooltip]="column.headerTooltip"
            >
              <div class="flex items-center">
                <div class="flex flex-col">
                  <span class="{{ column.titleClass }}">{{
                    column.title
                  }}</span>
                  @if (column?.subTitle) {
                    <span class="text-gray-500 text-xs text-center">{{
                      column.subTitle
                    }}</span>
                  }
                </div>
                <div
                  [ngClass]="{
                    'pointer-events-none':
                      !tableConfig.isSortable ||
                      column.sortDisabled ||
                      loadingTable ||
                      disableTableActions,
                  }"
                  mat-sort-header
                  arrowPosition="before"
                  class="flex group items-center ml-4"
                >
                  @if (tableConfig.changeColumnOption) {
                    @if (canMoveLeft(column.key)) {
                      <button
                        [attr.aria-label]="'item-button'"
                        [disabled]="!tableConfig.changeColumnOption"
                        [matTooltip]="'Move column left'"
                        class="text-gray-500 opacity-0 group-hover:opacity-80 duration-300 flex items-center remove-btn hover:!opacity-50"
                        (click)="
                          onMoveColumnLeft(column.key); $event.stopPropagation()
                        "
                      >
                        <mat-icon
                          class="text-gray-500 text-md material-icons-outlined"
                          >chevron_left</mat-icon
                        >
                      </button>
                    }
                    @if (canMoveRight(column.key)) {
                      <button
                        [attr.aria-label]="'item-button'"
                        [disabled]="!tableConfig.changeColumnOption"
                        [matTooltip]="'Move column right'"
                        class="text-blue-500 opacity-0 group-hover:opacity-80 duration-300 flex items-center remove-btn hover:!opacity-50"
                        (click)="
                          onMoveColumnRight(column.key);
                          $event.stopPropagation()
                        "
                      >
                        <mat-icon
                          class="text-gray-500 text-md material-icons-outlined"
                          >chevron_right</mat-icon
                        >
                      </button>
                    }
                  }
                  @if (tableConfig.deleteOption) {
                    @if (canRemoveColumn()) {
                      <button
                        [attr.aria-label]="'item-button'"
                        [disabled]="!tableConfig.deleteOption"
                        [matTooltip]="'Delete column'"
                        class="text-gray-500 opacity-0 group-hover:opacity-80 duration-300 flex items-center remove-btn hover:!opacity-50"
                        (click)="
                          onRemoveColumn(column.key); $event.stopPropagation()
                        "
                      >
                        <mat-icon
                          class="text-gray-500 text-md material-icons-outlined"
                          >close</mat-icon
                        >
                      </button>
                    }
                  }
                </div>
              </div>
            </th>
            <td
              class="{{ column.class }}"
              [ngClass]="{
                'cursor-pointer': isPointerCursorEnabled(row),
                'cursor-default':
                  !isRowCorrupted(row) && !isPointerCursorEnabled(row),
                'cursor-not-allowed': isRowCorrupted(row),
              }"
              mat-cell
              *matCellDef="let row; let i = dataIndex"
              (click)="isRowCorrupted(row) ? $event.stopPropagation() : null"
              (keydown)="isRowCorrupted(row) ? $event.stopPropagation() : null"
            >
              @if (!column.template) {
                <span
                  [matTooltipDisabled]="!column.tooltip"
                  [matTooltip]="
                    column.tooltip ? (row | handleFunction: column.tooltip) : ''
                  "
                  [innerHTML]="
                    column.value
                      ? (row | handleFunction: column.value)
                      : row[column.key]
                  "
                ></span>
              } @else {
                <ng-container
                  *ngTemplateOutlet="
                    checkSignal(column.template)
                      ? column.template()
                      : column.template;
                    context: {
                      row: row,
                      dataIndex: unfilteredIndex(row, i),
                    }
                  "
                >
                </ng-container>
              }</td
          ></ng-container>
        }

        <ng-container matColumnDef="row-actions">
          <th
            class="w-[10%] simple-table__action-column"
            mat-header-cell
            *matHeaderCellDef
          >
            {{
              !rowActionsConfig && tableConfig.rowActions?.length === 1
                ? ''
                : 'Actions'
            }}
          </th>
          <td
            class="w-[10%] simple-table__action-column"
            mat-cell
            *matCellDef="let row; let i = dataIndex"
            (click)="isRowCorrupted(row) ? $event.stopPropagation() : null"
          >
            @if (
              !tableConfig.disableActions ||
              !(row | handleFunction: tableConfig.disableActions)
            ) {
              @if (rowActionsConfig?.menuRowActions) {
                <button
                  type="button"
                  mat-icon-button
                  class="material-icons-outlined"
                  [disabled]="
                    loadingTable || disableTableActions || isRowCorrupted(row)
                  "
                  [attr.aria-label]="'actionMenu'"
                  [matMenuTriggerFor]="menuRowActions"
                  [matMenuTriggerRestoreFocus]="false"
                  [matTooltip]="
                    isRowCorrupted(row) ? 'Corrupted information' : ''
                  "
                >
                  @if (rowActionsConfig?.svgIcon) {
                    <div
                      [ngStyle]="{
                        'background-image':
                          'url(/assets/images/icons/simple-table/' +
                          rowActionsConfig?.menuRowActionsIcon +
                          '.svg)',
                      }"
                      class="bg-no-repeat h-[30px] w-[30px]"
                    ></div>
                  } @else {
                    {{ rowActionsConfig?.menuRowActionsIcon ?? 'settings' }}
                  }
                </button>
                <mat-menu #menuRowActions="matMenu">
                  @for (action of tableConfig.rowActions; track action) {
                    @if (
                      !action.visible || (row | handleFunction: action.visible)
                    ) {
                      <button
                        type="button"
                        mat-menu-item
                        [attr.aria-label]="action.id + 'Action'"
                        [disabled]="
                          loadingTable ||
                          disableTableActions ||
                          isRowCorrupted(row)
                        "
                        (click)="onTableAction(row, action.id, i)"
                      >
                        <div class="flex">
                          @if (action.svgIcon && action.icon) {
                            <div
                              [ngStyle]="{
                                'background-image':
                                  'url(/assets/images/icons/simple-table/' +
                                  action.icon +
                                  '.svg)',
                              }"
                              class="bg-no-repeat h-[30px] w-[30px] mr-1"
                            ></div>
                          } @else {
                            <div class="mr-1">
                              <em
                                class="material-icons-outlined {{
                                  action.class
                                }}"
                              >
                                {{ action.icon }}
                              </em>
                            </div>
                          }
                          <span>{{ action?.label?.(row) ?? '' }}</span>
                        </div>
                      </button>
                    }
                  }
                </mat-menu>
              } @else {
                <div class="flex justify-center items-center">
                  @for (action of tableConfig.rowActions; track action) {
                    @if (
                      !action.visible || (row | handleFunction: action.visible)
                    ) {
                      <button
                        type="button"
                        [attr.aria-label]="action.id + 'Action'"
                        class="material-icons-outlined {{ action.class }}"
                        [matTooltipDisabled]="
                          loadingTable || disableTableActions
                        "
                        [matTooltip]="
                          isRowCorrupted(row)
                            ? 'Corrupted information'
                            : (action?.label?.(row) ?? '')
                        "
                        [disabled]="
                          loadingTable ||
                          disableTableActions ||
                          isRowCorrupted(row)
                        "
                        (click)="onTableAction(row, action.id, i)"
                      >
                        @if (action.svgIcon && action.icon) {
                          <div
                            [ngStyle]="{
                              'background-image':
                                'url(/assets/images/icons/simple-table/' +
                                action.icon +
                                '.svg)',
                            }"
                            class="bg-no-repeat h-[27px] w-[27px] mx-1"
                          ></div>
                        } @else {
                          {{ action.icon }}
                        }
                      </button>
                    }
                  }
                </div>
              }
            }
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: tableConfig.stickyHeader"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns; let index = dataIndex"
          [attr.id]="
            tableConfig.idPath
              ? (lodashGet(row, tableConfig.idPath) ?? null)
              : null
          "
          [ngClass]="{
            'theme-bg-4--row border-blue-color-1--row-2':
              tableConfig.highlightRowOnClick && isHighlighted(row),
            'cursor-pointer': isPointerCursorEnabled(row),
            'cursor-default':
              !isRowCorrupted(row) && !isPointerCursorEnabled(row),
            'simple-table__row--hoverable':
              tableConfig.highlightRowOnHover &&
              !loadingTable &&
              !isRowCorrupted(row),
            'cursor-not-allowed': isRowCorrupted(row),
            'theme-bg-2--row': tableConfig.zebraStriping && index % 2 === 0,
            'opacity-50 grayscale': isRowCorrupted(row),
          }"
          [matTooltip]="isRowCorrupted(row) ? 'Corrupted information' : ''"
          (click)="
            !loadingTable && !isRowCorrupted(row) ? onRowClick(row) : null
          "
          (keyup)="(null)"
          style="padding-left: 30px"
        ></tr>
        @if (tableConfig.templateExpandible) {
          <tr
            mat-row
            *matRowDef="let row; columns: ['expandedDetail']"
            class="simple-table__detail-row"
          ></tr>
        }
        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length">
            <div class="text-center text-base p-4">
              <phoenix-no-data></phoenix-no-data>
            </div>
          </td>
        </tr>
      </table>
      @if (pageSize >= 10 && tableConfig.hasPaginator) {
        <mat-paginator
          #paginator
          [pageSizeOptions]="[10, 20, 50, 100]"
          [length]="dataSourceLength"
          [pageSize]="pageSize"
          [pageIndex]="pageIndex"
          [disabled]="loadingTable || disableTableActions"
          (page)="onPaginateChange()"
          aria-label="Select page"
        >
        </mat-paginator>
      }
    </div>
  </div>

  <ng-content select="[extraOptionsAfter]"></ng-content>
</div>

@if (!dataSource || !tableConfig) {
  <div class="flex items-center justify-center">
    <mat-spinner [diameter]="80" class="m-10"></mat-spinner>
  </div>
}

<ng-template #columnFilterDialogForm>
  <mat-form-field class="w-full">
    <mat-label>Columns</mat-label>
    <mat-select
      [attr.aria-label]="'simple-table-column-filter'"
      [formControl]="displayedColumnsControl"
      multiple
    >
      @for (columns of tableConfig.displayedColumns; track $index) {
        <mat-option [value]="columns">{{ getColumnName(columns) }}</mat-option>
      }
    </mat-select>
    <mat-error> <small>This field is required</small></mat-error>
  </mat-form-field>
</ng-template>
